export default {
	exhibitionPageRoot: 'syning',

	apiRoot: process.env.REACT_APP_API_ROOT,
	videoRoot: process.env.REACT_APP_VIDEO_PATH,
	mediaRoot: process.env.REACT_APP_MEDIA_PATH,

	gaTrackingId: 'GTM-NJZM4ZV9'
}
